import { useState, useEffect } from 'react'
import InstruccionesImage from './components/Instructions'
import { useTranslation } from 'react-i18next'
import { getBrowserAndOS } from './utils/getBrowserAndOs'

interface InstruccionesScreenProps {
  token: string
  brand: string
  documentTitle: string
  language: string
  startDate: string
  endDate: string
  meetingNumber: string
  password: string
}

const InstruccionesScreen = ({
  token,
  brand,
  documentTitle,
  language,
  startDate,
  endDate,
  meetingNumber,
  password,
}: InstruccionesScreenProps) => {
  const { t } = useTranslation()
  const [specificOS, setSpecificOS] = useState('Unknown OS')
  const [specificBrowser, setSpecificBrowser] = useState('Unknown Browser')

  useEffect(() => {
    document.title = documentTitle

    getBrowserAndOS(setSpecificOS, setSpecificBrowser)
  }, [documentTitle])

  return (
    <div className="flex flex-col w-[329px] text-center md:text-left md:w-[843px] text-generic-neutral-900 font-aeonik">
      {brand === 'vidacaixa' && (
        <h1 className="font-bold mt-8 text-center" style={{ fontSize: '24px' }}>
          {t('zoom.instructions.titleCaixa')}
        </h1>
      )}
      <div className="flex flex-col md:gap-4 mt-8">
        <p className="mb-8 md:mb-0 md:text-[20px]">
          {t('zoom.instructions.titleQida')}
        </p>
        <p className="md:text-[20px] font-bold">
          {t('zoom.instructions.subtitle')}
        </p>
        <p className="md:text-[20px] font-bold">
          {t('zoom.instructions.browser')}{' '}
          <span className="font-normal">{specificBrowser}</span>
        </p>
        <p className="mb-8 md:mb-0 md:text-[20px] font-bold">
          {t('zoom.instructions.os')}{' '}
          <span className="font-normal">{specificOS}</span>
        </p>
        <InstruccionesImage
          browser={specificBrowser}
          os={specificOS}
          brand={brand}
          token={token}
          language={language}
          startDate={startDate}
          endDate={endDate}
          meetingNumber={meetingNumber}
          password={password}
        />
      </div>
    </div>
  )
}

export default InstruccionesScreen
